const doc = [({"zh_tw":({"adminComponentHotelMail":({"arrangedInformationDescription":"當設施確認預訂時，這將顯示在電子郵件中。", "hotelMailTitle":"電子郵件設置", "informationTitle":"連絡事項"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;